import { Card, Badge, Tooltip } from "flowbite-react";
import { FaCheckCircle, FaTimesCircle, FaMoneyBillWave } from "react-icons/fa";
import { HiCalendar, HiIdentification } from "react-icons/hi";
import { formatDocument } from "../../../utils/utils";
import TitleStripe from "../../common/TitleStripe";

export default function RendaPresumidaPF({ data }) {
  if (!data) return null;

  const { documento, dataReferencia, dadosPositivos: dp } = data;

  console.log(data);

  return (
    <div>
      {data?.statusRetorno == 1 && (
        <>
          {" "}
          <TitleStripe>💰 Renda Presumida</TitleStripe>
          <div className="w-full mx-auto rounded-2xl shadow-sm border border-slate-200 p-4 mt-4 bg-white/70 backdrop-blur">
            {/* Header */}
            <div className="flex flex-row justify-between gap-3 items-center mb-4">
              <div>
                <div className="text-sm text-slate-500 flex items-center gap-1">
                  <HiIdentification /> {formatDocument(documento)}
                </div>
                <div className="text-sm text-slate-500 flex items-center gap-1">
                  <HiCalendar /> Referência: {dataReferencia}
                </div>
              </div>

              <div className="flex items-center gap-2">
                {dp?.habilitado ? (
                  <span className="inline-flex items-center gap-2 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200 px-3 py-1 text-sm font-medium">
                    💰 Habilitado em Dados Positivos
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-2 rounded-full bg-rose-50 text-rose-700 border border-rose-200 px-3 py-1 text-sm font-medium">
                    🚫 Não habilitado
                  </span>
                )}
              </div>
            </div>

            {/* KPIs */}
            <div className="grid grid-cols-3 gap-4 mb-4">
              {/* Renda Presumida */}
              <div className="rounded-2xl border border-emerald-200 bg-gradient-to-br from-emerald-50 to-white p-4">
                <p className="text-xs uppercase tracking-wide text-emerald-700/80">
                  Renda Presumida
                </p>
                <p className="mt-1 text-2xl font-bold text-emerald-700">
                  {dp?.rendaPresumidaFmt}
                </p>
                <p className="text-[11px] text-slate-500 mt-1">
                  estimativa mensal
                </p>
              </div>

              {/* Faixa de Renda */}
              <div className="rounded-2xl border border-sky-200 bg-gradient-to-br from-sky-50 to-white p-4">
                <p className="text-xs uppercase tracking-wide text-sky-700/80">
                  Faixa de Renda
                </p>
                <p className="mt-1 text-xl font-semibold text-sky-700">
                  {dp?.faixaRenda?.descricao}
                </p>
                {dp?.faixaRenda?.minFmt && (
                  <div className="mt-2 flex flex-wrap gap-2 text-xs">
                    <span className="rounded-full bg-white border border-sky-200 px-2 py-1">
                      {dp?.faixaRenda?.minFmt}
                    </span>
                    <span className="mt-1">até</span>
                    <span className="rounded-full bg-white border border-sky-200 px-2 py-1">
                      {dp?.faixaRenda?.maxFmt}
                    </span>
                  </div>
                )}
              </div>

              {/* Faixa em SM */}
              <div className="rounded-2xl border border-indigo-200 bg-gradient-to-br from-indigo-50 to-white p-4">
                <p className="text-xs uppercase tracking-wide text-indigo-700/80">
                  Faixa em Salários Mínimos
                </p>
                <p className="mt-1 text-xl font-semibold text-indigo-700">
                  {dp?.faixaSalarioMinimo?.descricao}
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
